import React from "react";

export default function ReplyIcon(props: React.SVGProps<any>) {
  return (
    <svg viewBox="0 0 14 12" width="1em" height="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" d="M-133-108h729V29h-729z" />
        <path
          fill="#A5ADBA"
          fillRule="nonzero"
          d="M6.417 4.002V.286a.286.286 0 0 0-.18-.264.296.296 0 0 0-.318.062L.085 5.798a.282.282 0 0 0 0 .404l5.834 5.714a.295.295 0 0 0 .317.062.286.286 0 0 0 .18-.264V8.01c1.264.062 6.194.478 7.012 3.213a.29.29 0 0 0 .322.203c.143-.02.25-.14.25-.283 0-6.555-6.217-7.1-7.583-7.141z"
        />
      </g>
    </svg>
  );
}
